import shallowEquals from 'zustand/shallow';

const equalityFn = shallowEquals;
export { equalityFn, shallowEquals };

export * from './modules/createStore';
